import {transitionOpen, transitionClose, bodyLock} from "./transitions.js";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';


const stationary = document.querySelector('[data-widget-stationary]')
const triggers = document.querySelectorAll('[data-widget-trigger]')
const overlays = document.querySelectorAll('[data-widget-overlay]')
const researchItems = document.querySelector('[data-research-items]')

const widgets = [];

let floatingWidgetsWereVisible = false

const closeWidget = async widget =>  {
  await transitionClose(`overlay-${widget.name}`, document.body, widget.triggers, widget.overlay)
  widget.open = false

  if (floatingWidgetsWereVisible) {
    document.body.classList.add('floating-buttons-visible')
    floatingWidgetsWereVisible = false
  }
  clearAllBodyScrollLocks()

  pushEvent({
    event: 'widget-close',
    widget: {
      name: widget.name,
      type: 'overlay'
    }
  })
}

const closeOpenWidgets = async () => {
  widgets.filter(w => w.open).forEach(async w => await closeWidget(w))
}

const openWidget = async widget => {

  pushEvent({
    event: 'widget-open',
    widget: {
      name: widget.name,
      type: 'overlay'
    }
  })

  if (document.body.classList.contains('floating-buttons-visible')) {
    floatingWidgetsWereVisible = true
    document.body.classList.remove('floating-buttons-visible')
  }

  window.dispatchEvent(new CustomEvent('menus:close'))

  await closeOpenWidgets()

  widget.open = true

  await transitionOpen(`overlay-${widget.name}`, document.body, widget.triggers, widget.overlay)

  bodyLock(widget.overlay)
}

overlays.forEach(overlay => {
  const triggers = document.querySelectorAll(`[data-widget-trigger="${overlay.getAttribute('data-widget-overlay')}"]`)
  const widget = {
    name: overlay.getAttribute('data-widget-overlay'),
    overlay: overlay,
    triggers: Array.from(triggers),
    open: false,
  }
  widgets.push(widget)

  overlay.querySelector('[data-widget-close]').addEventListener('click', (e) => {
    e.preventDefault()
    closeWidget(widget)
  })

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault()
      openWidget(widget)
    })
  })
})

window.addEventListener('widgets:close', async e => await closeOpenWidgets())


if (stationary) {
  // if not in viewport, add class to body "floating-buttons-visible", if in viewport, remove class:
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.body.classList.remove('floating-buttons-visible')
      } else {
        document.body.classList.add('floating-buttons-visible')
      }
    })
  }, {threshold: 0.5})

  observer.observe(stationary)

} else {
  document.body.classList.add('floating-buttons-visible')
}

const pushEvent = data => {
  if (window.dataLayer) {
    window.dataLayer.push(data)
  } else {
    console.log('gtm.event.localhost', data)
  }
}

researchItems.querySelectorAll('a').forEach(a => {
  a.addEventListener('click', e => {
    const newTab = e.metaKey || e.ctrlKey

    if (newTab) e.preventDefault();
    let title = a.getAttribute('data-title')
    let path = getResearchPath() + ' > ' + title
    pushEvent({
      event: 'research-item-click',
      research: {
        path,
        title,
        level: activeLevel,
        type: 'link'
      }
    })
    if (newTab) {
      document.location.href = a.getAttribute('href')
    }

  })
})

const getResearchPath = () => {
  return activeItems.map(e => e.querySelector('button').getAttribute('data-title')).join(' > ')
}

let activeLevel = null
let activeItems = [];
researchItems.querySelectorAll('[data-research-item]').forEach(item => {
  const level = item.getAttribute('data-research-item')

  item.querySelector('[data-research-button]').addEventListener('click', e => {
    activeLevel = level
    item.classList.add('child-item-is-active')
    activeItems.push(item)
    researchItems.classList.add('child-item-is-active-' + level)

    pushEvent({
      event: 'research-item-level',
      research: {
        path: getResearchPath(),
        title: item.querySelector('button').getAttribute('data-title'),
        level: level,
        type: 'level'
      }
    })
  })

  const close = item.querySelector('ul > li:first-child [data-research-item-close]')

  if (close) {
    close.addEventListener('click', e => {
      researchItems.classList.remove('child-item-is-active-' + activeLevel)
      activeLevel--
      let lastActiveItem = activeItems.pop()
      if (lastActiveItem) {
        lastActiveItem.classList.remove('child-item-is-active')
      }

      if (activeLevel > -1) {
        researchItems.classList.add('child-item-is-active-' + activeLevel)
      }
    })
  }

})

